import { Flame, Snowflake } from "lucide-react";

const ITEMS = [
  "NATE Certified Technicians",
  "EPA 608 Universal",
  "Carrier Authorized Dealer",
  "100% Satisfaction Guarantee",
  "Same-Day Emergency Dispatch",
  "15,000+ Homes Served",
  "Free Second Opinions",
];

export default function MarqueeStrip() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="marquee-strip"
      className="group relative overflow-hidden border-y border-white/[0.07] bg-navy-900/60 py-5"
    >
      <div className="flex w-max animate-marquee items-center gap-10 pr-10 group-hover:[animation-play-state:paused]">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="whitespace-nowrap font-mono text-[11px] uppercase tracking-[0.26em] text-slate-400">
              {item}
            </span>
            {i % 2 === 0 ? (
              <Flame className="h-3.5 w-3.5 shrink-0 text-forge" />
            ) : (
              <Snowflake className="h-3.5 w-3.5 shrink-0 text-ice" />
            )}
          </span>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-navy-950 to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-navy-950 to-transparent" />
    </div>
  );
}
